// extracted by mini-css-extract-plugin
export default {"team":"Team_team__8dI4V","title":"Team_title__qjif4","content":"Team_content__V3mYZ"};